import type { IconData } from '@stacksjs/iconify-core'

export const table: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 22H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M4 20h16V4H4Z\"/><path fill=\"currentColor\" d=\"M9 22a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v18a1 1 0 0 1-1 1m6 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v18a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M21 10H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0 6H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default table
